module.exports = __webpack_public_path__ + "img/pogo.b9795116.png";